import { render } from "./Regra.vue?vue&type=template&id=68931fab"
import script from "./Regra.vue?vue&type=script&lang=js"
export * from "./Regra.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__